<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="1500"
    overlay-opacity="0.59"
  >
    <v-card
      class="pa-2"
      style="min-height: 600px"
    >
      <div class="d-flex flex-column mx-4 my-4">
        <div class="d-flex">
          <div class="text-h5 font-weight-light mb-10">
            {{ $t('broker.activePositions.orderLog') }}
          </div>
          <v-spacer />
          <v-btn icon @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Progress circular 
        <div
          v-if="loading"
          class="loading-indicator d-flex justify-center align-center"
          style="height: 500px"
        >
          <v-progress-circular indeterminate color="primary" :size="110" :width="7"></v-progress-circular>
          <span class="ml-3 text-h4">{{ $t('extras.loadingDot') }} </span>
        </div>-->

        <!-- rfqElements data-table -->
        <v-data-table
          dense
          :headers="headers"
          :items="items"
          item-key="rfq_id"
        > 
          <template #[`item.partner_name`]="{ item }">
            <v-chip
              v-if="isBroker && item.isPartner"
              small
              style="background:#1f52915e !important; color: white !important;"
              outlined
              class="primary"
            >
              {{ item.partnerName }}
            </v-chip>
            <span v-else>-</span>
          </template>

          <template #[`item.rfq_maturity`]="{ item }">
            <span>{{ item.rfq_security === 'FXNDF' ? formatMaturityDate(item.rfq_maturity) : '-' }}</span>
          </template>

          <template #[`item.rfq_spotsett`]="{ item }">
            <span>{{ item.rfq_security !== 'FXNDF' ? item.rfq_spotsett.toUpperCase() : '-' }}</span>
          </template>

          <template #[`item.rfq_side`]="{ item }">
            <span 
              :class="{
                'alive--text': item.rfq_side.toUpperCase() === 'BUY',
                'orangeColor--text': item.rfq_side.toUpperCase() === 'SELL'
              }"
            >
              {{ $t('quoteInfo.' + item.rfq_side.toLowerCase()) }} 
            </span>
          </template>

          <template #[`item.rfq_id`]="{ item }">
            <copyable-id :id="item.rfq_id" type="RFQ" />
          </template>
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import * as utils from '../../utils.js'
import CopyableId from '@/components/common/CopyableId.vue'

export default {
  name: 'OrderLogDialog',
  components: { CopyableId },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    isBroker: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headers () {
      const headersList = [
        { text: this.$t('broker.client'), value: 'client_name', sortable: false },
        { text: this.$t('quoteInfo.dealTime'), value: 'rfq_deal_time', sortable: false },
        { text: this.$t('quoteInfo.ccy'), value: 'rfq_ccy', sortable: false },
        { text: this.$t('quoteInfo.side'), value: 'rfq_side', sortable: false },
        { text: this.$t('quoteInfo.amount'), value: 'rfq_amount', sortable: false },
        { text: this.$t('quoteInfo.rate'), value: 'rfq_px', sortable: false },
        { text: this.$t('quoteInfo.volumeCcyBrl'), value: 'volume', sortable: false },
        { text: this.$t('quoteInfo.settlement'), value: 'rfq_spotsett', sortable: false },
        { text: this.$t('quoteInfo.maturityText'), value: 'rfq_maturity', sortable: false },
        { text: this.$t('quoteInfo.bankName'), value: 'bank_label', sortable: false },
        { text: this.$t('quoteInfo.id'), value: 'rfq_id', sortable: false },
      ]
      if (this.isBroker) {
        headersList.unshift({ text: this.$t('reports.partnerName'), value: 'partner_name', sortable: false })
      }
      return headersList
    }
  },
  methods: {
    formatMaturityDate (date) {
      return utils.formatMaturityDate(date)
    }
  }
}
</script>
